import React from 'react'
//react-icons
import { SiMicrosoftsqlserver } from 'react-icons/si'
//icons
import marketplace from '../assets/images/marketplace.png'
import charity from '../assets/images/charity.png'
import community from '../assets/images/community.png'
import decentralized from '../assets/images/decentralized.png'
//type animation
import { TypeAnimation } from 'react-type-animation'
//motion
import { motion } from 'framer-motion'
//variants'
import { fadeIn } from '../variants';


const Features = () => {
    return (
        <div className='min-h-screen font-mooli' id='about' >
            <div className='flex flex-col space-y-8 justify-center items-center py-12 '>

                <h1 className='text-6xl max-w-6xl text-center font-medium text-[#283618]'>Features</h1>
                {/* marketplace */}
                <motion.div
                    variants={fadeIn('up', 0.3)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{ once: false, amount: 0.7 }}
                    className='flex max-w-4xl gap-4 shadow-xl p-4 rounded-xl bg-white/10 backdrop-blur-3xl'>
                    <img src={marketplace} alt='marketplace' className='h-28 ' />
                    <div className='flex flex-col justify-center items-start space-y-1'>
                        <h1 className='font-bold text-2xl text-[#283618]'>NFT Marketplace</h1>
                        <p className='text-[#283618] font-semibold'>A Non-Fungible Token (NFT) marketplace is an online platform or marketplace where users can buy, sell, and trade NFTs. NFTs are unique digital assets that are indivisible and represent ownership or proof of authenticity of a specific item, piece of art, collectible, or digital content</p>
                    </div>
                </motion.div>
                {/* Community and Content */}
                {/* <motion.div
                    variants={fadeIn('up', 0.3)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{ once: false, amount: 0.7 }}
                    className='flex max-w-4xl gap-4 shadow-xl p-4 rounded-xl bg-white/10 backdrop-blur-3xl'>
                    <img src={community} alt='marketplace' className='h-28 ' />
                    <div className='flex flex-col justify-center items-start space-y-1'>
                        <h1 className='font-bold text-2xl text-[#283618]'>Community and Content</h1>
                        <p className='text-[#283618] font-semibold'>A social platform where users can engage in discussions about spiritual topics, share experiences, and access a library of spiritual content. Contributors can earn CHC for sharing their wisdom and insights.</p>
                    </div>
                </motion.div> */}
                {/* Decentralized Governance */}
                <motion.div
                    variants={fadeIn('up', 0.3)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{ once: false, amount: 0.7 }}
                    className='flex max-w-4xl gap-4 shadow-xl p-4 rounded-xl bg-white/10 backdrop-blur-3xl'>
                    <img src={decentralized} alt='marketplace' className='h-28 ' />
                    <div className='flex flex-col justify-center items-start space-y-1'>
                        <h1 className='font-bold text-2xl text-[#283618]'>Decentralization</h1>
                        <p className='text-[#283618] font-semibold'>Bitcoin operates on a decentralized network of computers, known as nodes, where no single entity or government controls the currency. This decentralization is achieved through a distributed ledger called the blockchain.</p>
                    </div>
                </motion.div>
                {/* Block chain technology */}
                <motion.div
                    variants={fadeIn('up', 0.3)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{ once: false, amount: 0.7 }}
                    className='flex max-w-4xl gap-4 shadow-xl p-4 rounded-xl bg-white/10 backdrop-blur-3xl'>

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-44 h-44">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z" />
                    </svg>

                    <div className='flex flex-col justify-center items-start space-y-1'>
                        <h1 className='font-bold text-2xl text-[#283618]'>Blockchain Technology</h1>
                        <p className='text-[#283618] font-semibold'>Bitcoin's blockchain is a public ledger that records all transactions made with the cryptocurrency. It is a chronological chain of blocks, each containing a batch of transactions, secured using cryptographic techniques.</p>
                    </div>
                </motion.div>
                {/* Charity and Donations */}
                {/* <motion.div
                    variants={fadeIn('up', 0.3)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{ once: false, amount: 0.7 }}
                    className='flex max-w-4xl gap-4 shadow-xl p-4 rounded-xl bg-white/10 backdrop-blur-3xl'>
                    <img src={charity} alt='marketplace' className='h-28 ' />
                    <div className='flex flex-col justify-center items-start space-y-1'>
                        <h1 className='font-bold text-2xl text-[#283618]'>Charity and Donations</h1>
                        <p className='text-[#283618] font-semibold'>Users can donate TIME to charitable causes supported by crypto healers and the community, fostering a culture of generosity and compassion.</p>
                    </div>
                </motion.div> */}

            </div>

        </div>
    )
}

export default Features
